import { useCreateTrialForOpenedExaminationMutation } from '@generated/graphql';
import { CircularLoading, useToast } from '@myhrbox/myhrbox-frontend-core';
import AssesmentAccessCard from 'components/AssesmentAccessCard';
import { EXAMINATION_IS_NOT_AVAILABLE_ERROR_MESSAGE } from 'constants/assessment';
import ROUTES from 'constants/routes';
import qs from 'qs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMe from 'store/user/useMe';
import { getApolloErrorMessage } from 'utils/errorsParse';
import { getIsNeedToGoToConfirmUserData } from 'utils/user';

const ExaminationReceive = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();
  const { me } = useMe();
  const [trialId, setTrialId] = useState<string>();
  const { examinationId } = useParams<{ examinationId: string }>();
  const [receiveExamination] = useCreateTrialForOpenedExaminationMutation();
  const [showAssesmentAccessCard, setShowAssesmentAccessCard] = useState(false);

  const onError = () => {
    navigate(ROUTES.ASSESSMENT, { replace: true });
    showErrorToast(t('assessment.instruction.error.assessmentUnavailable'));
  };

  useEffect(() => {
    if (!examinationId) {
      onError();
    } else {
      receiveExamination({
        variables: {
          examinationId,
        },
      })
        .then((res) => {
          const resTrialId = res.data?.createTrialForOpenedExamination.id;
          if (resTrialId) {
            setTrialId(resTrialId);
          } else {
            onError();
          }
        })
        .catch((err) => {
          const errorMessage = getApolloErrorMessage(err);

          if (errorMessage === EXAMINATION_IS_NOT_AVAILABLE_ERROR_MESSAGE) {
            setShowAssesmentAccessCard(true);
          } else {
            onError();
          }
        });
    }
  }, []);

  useEffect(() => {
    if (me && trialId) {
      const assesmentUrl = `${ROUTES.ASSESSMENT}/${trialId}`;

      if (!me.language) {
        navigate({
          pathname: ROUTES.LANGUAGE_SELECT,
          search: qs.stringify({ redirectUrl: encodeURIComponent(assesmentUrl) }),
        });
      } else if (getIsNeedToGoToConfirmUserData(me)) {
        navigate({
          pathname: ROUTES.CONFIRM_USER_DATA,
          search: qs.stringify({ redirectUrl: encodeURIComponent(assesmentUrl) }),
        });
      } else {
        navigate(assesmentUrl, { replace: true });
      }
    }
  }, [me, trialId]);

  if (showAssesmentAccessCard) return <AssesmentAccessCard />;

  return <CircularLoading />;
};

export default ExaminationReceive;
